import { environment } from '@environments/environment';

/**
 * Log the Google Analytics send analytics event to the console in non-production environments to prevent the event.
 * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
 * @param action - the action to be (ex. click)
 * @param dataLabel - the label associated with the action
 */
export function logGoogleAnalytics(category: string, action: string, dataLabel: string): void {
  /* istanbul ignore else */
  if (environment && !environment.production) {
    console.log('Category:', category, '\n', 'Action:', action, '\n', 'Data Label:', dataLabel);
  }
}
